<template>
  <!-- Table Container Card -->
  <b-card>

    <validation-observer ref="tieredKYCReportRules">
      <b-form @submit.prevent="handleSubmit">
        <b-row class="match-height">
          <!-- Start Date-->
          <b-col md="3">
            <DatePickerField
              id="start-date"
              v-model="tieredKYCFormData.startDate"
              :min-date="new Date()"
              :label="$t('Start Date')"
              :error-name="$t('Start Date')"
              :config="datePickerConfig"
              :placeholder="$t('Select Date')"
              rules="required"
            />
          </b-col>
          <!--  Start Date -->

          <!-- End Date-->
          <b-col md="3">
            <DatePickerField
              id="end-date"
              v-model="tieredKYCFormData.endDate"
              :min-date="new Date()"
              :label="$t('End Date')"
              :error-name="$t('End Date')"
              :config="datePickerConfig"
              :placeholder="$t('Select Date')"
              rules="required"
            />
          </b-col>
          <!--  End Date -->

          <b-col
            md="4"
            class="mt-2"
          >
            <Button
              :label="$t('Generate Report')"
              :loading="isLoading"
              :disabled="isDisabled"
              variant="primary"
              size="md"
              @click="handleSubmit"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BForm, BCol,
} from 'bootstrap-vue'
import { tableMixins } from '@core/mixins/table'
import { modalMixins } from '@core/mixins/modal'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { permissionMixin } from '@core/mixins/permission'
import { mapActions } from 'vuex'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import {
  toYearWithDate, toDateWithYear,
} from '@/helpers/formatDate'
import DatePickerField from '../../../forms/DatePickerField.vue'
import Button from '../../../components/button/Button.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    Button,
    DatePickerField,
    ValidationObserver,
    FullScreenSpinner,
  },
  directives: {
    Ripple,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      isBusy: false,
      isDisabledText: false,
      required,
      isLoading: false,
      isDisabled: false,
      showSpinner: false,
      toDateWithYear,
      tieredKYCFormData: {
        startDate: null,
        endDate: null,
      },
      datePickerConfig: {
        dateFormat: 'd/m/Y',
        maxDate: '',
        defaultDate: '',
      },
    }
  },
  methods: {
    ...mapActions({
      downloadThreeTieredKYCReport: 'reports/downloadThreeTieredKYCReport',
    }),
    handleSubmit() {
      this.$refs.tieredKYCReportRules.validate().then(async success => {
        if (success) {
          this.export3TieredKYCReport()
        }
      })
    },
    async export3TieredKYCReport() {
      try {
        const { startDate } = this.tieredKYCFormData
        const { endDate } = this.tieredKYCFormData
        this.isBusy = true
        this.showSpinner = true
        const response = await this.downloadThreeTieredKYCReport({
          startDate: startDate ? toYearWithDate(startDate) : null,
          endDate: endDate ? toYearWithDate(endDate) : null,
        })
        if (response.status === 200) {
          this.alertSuccessCustom({
            text: 'Your download is in progress and might take a little longer. Go to your ',
            link: {
              text: 'Download Manager',
              route: { name: 'download-manager' },
            },
            afterLinkText: ' to access the completed file.',
          })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
        this.showSpinner = false
      }
    },
  },
}
</script>

  <style lang="scss">
     @import '@core/scss/vue/libs/vue-select.scss';
  </style>
